import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { useIntl } from '@atlassian/jira-intl';
import type { OptionGroupHeader$key } from '@atlassian/jira-relay/src/__generated__/OptionGroupHeader.graphql';
import type { OptionFieldType } from '@atlassian/jira-issue-table-grouping-issue-create-utils/src/optimistic-responses/types.tsx';
import { RADIO_BUTTONS_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { TextGroupHeaderContent } from '../../../../common/text-group-header-content/index.tsx';
import { TagGroupHeaderContent } from '../../../../common/tag-group-header-content/index.tsx';
import messages from './messages.tsx';

export type Props = {
	optionGroupHeader: OptionGroupHeader$key | null;
	fieldType: OptionFieldType;
};

export const OptionGroupHeader = ({ optionGroupHeader, fieldType }: Props) => {
	const data = useFragment<OptionGroupHeader$key>(
		graphql`
			fragment OptionGroupHeader on JiraJqlOptionFieldValue {
				displayName
				option {
					value
				}
			}
		`,
		optionGroupHeader,
	);

	const { formatMessage } = useIntl();

	return fieldType === RADIO_BUTTONS_CF_TYPE ? (
		<TextGroupHeaderContent
			text={data?.displayName || data?.option?.value}
			noValueText={formatMessage(messages.noOption)}
		/>
	) : (
		<TagGroupHeaderContent
			text={data?.displayName || data?.option?.value}
			noValueText={formatMessage(messages.noOption)}
		/>
	);
};
